import styled from 'styled-components';

export const PanelBox = styled.div`
  border: 3px solid #838383;
  border-bottom-color: #fff;
  border-right-color: #fff;
  margin-bottom: 10px;
  padding: 5px;
  display: flex;
  justify-content: space-between;
`;

export const SmileBox = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 34px;
  width: 36px;
  border: 3px solid #fff;
  border-bottom-color: #838383;
  border-right-color: #838383;
  & i {
    font-size: 24px;
  }
`;
